import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Metrics = () => {
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/metrics`);
        setMetrics(response.data);
      } catch (error) {
        console.error('Error fetching metrics:', error);
        // Fallback data
        setMetrics([
          { label: 'Average Occupancy', value: '92%', description: 'Rata-rata tingkat hunian' },
          { label: 'ROI Increase', value: '+165%', description: 'Peningkatan ROI' },
          { label: 'Response Time', value: '< 2 Jam', description: 'Waktu respons complaint' },
          { label: 'Maintenance', value: '24/7', description: 'Layanan maintenance' }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <section className="relative -mt-24 z-20 px-6 lg:px-12" data-testid="metrics-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="glass-card rounded-2xl p-8 md:p-12 grid grid-cols-2 md:grid-cols-4 gap-8"
          data-testid="metrics-card"
        >
          {metrics.map((metric, index) => (
            <div key={index} className="text-center" data-testid={`metric-${index}`}>
              <div className="text-3xl md:text-4xl font-bold text-isk-teal mb-2">
                {metric.value}
              </div>
              <div className="text-sm font-semibold text-isk-text mb-1">
                {metric.label}
              </div>
              <div className="text-xs text-isk-muted">
                {metric.description}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Metrics;
